import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from './CredentialsService'

const UserRepository = RepositoryFactory.get('user')

class UserService {
  static async verifyEmail (email) {
    try {
      return await UserRepository.verifyEmail(email)
    } catch (error) {
      console.log(error)
    }
  }

  static async getUsers (params) {
    try {
      return await UserRepository.getUsers(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getUser (userId, params) {
    try {
      return await UserRepository.getUser(CredentialsService.getCurrentTenantId(), userId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateUser (userId, data) {
    try {
      return await UserRepository.updateUser(CredentialsService.getCurrentTenantId(), userId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async createUser (data) {
    try {
      return await UserRepository.createUser(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }
}

export default UserService
